import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authRoutes } from './core/auth/auth.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token-interceptor';

/**
 * Warm up Amplify's auth state before the router runs its first navigation.
 * Without this, the very first guard evaluation happens before Amplify has
 * finished hydrating its session, so the guard's decision (allow vs. show the
 * "session expired" dialog) was inconsistent on the first load and only became
 * correct after a manual refresh.
 */
function warmUpAmplifyAuth(): () => Promise<void> {
  return async () => {
    try {
      await fetchAuthSession();
    } catch {
      // No valid session yet — the guard will handle it on navigation.
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideRouter(authRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: warmUpAmplifyAuth,
      multi: true,
    },
  ],
};
